import React from 'react';

const fixedClue = (props) => {
  return (
    <React.Fragment>
      <dt className="clueNumber">{props.clueNumber}</dt>
      <dd className="clueValue">
        {props.children}
      </dd>
    </React.Fragment>
  );
};

export default fixedClue;
